import { createStore } from 'vuex';
import task from './modules/task';
import taskList from './modules/taskList';
// 后台接口返回参数类
export interface IAxiosResponseData {
  status: number;
  message: string;
  data: any;
}

export default createStore({
  modules: {
    task,
    taskList,
  },
});
